<div class="right-rail-vertical-expander">
    <div
        class="right-rail-vertical-expander__header"
        [ngClass]="{ 'right-rail-vertical-expander__header--expanded': expanded }"
        (click)="toggleExpand()"
    >
        <cds-icon
            class="right-rail-vertical-expander__header-leading-icon"
            [ngClass]="classNames"
            *ngIf="icon"
            [solid]="solid"
            shape="{{ icon }}"
            size="16"
        ></cds-icon>
        <div class="right-rail-vertical-expander__header-text">
            {{ headerText }}
        </div>
        <cds-icon
            class="right-rail-vertical-expander__header-expander"
            shape="angle"
            direction="{{ expanded ? 'down' : 'right'}}"
            size="16"
        ></cds-icon>
    </div>
    <div
        class="right-rail-vertical-expander__body"
        [hidden]="!expanded"
    >
        <ng-content></ng-content>
    </div>
</div>
